import Vue from 'vue';
import Vuex from 'vuex';
import App from './src/doctor-search/App.vue';
import { BlueSearch, store } from '@bluemodus/blue-search';
import '@bluemodus/blue-search/dist/style.css';
window.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('#doctorSearch');
  const options = { ...el.dataset };
  Vue.config.productionTip = false;

  Vue.use(Vuex);
  Vue.use(BlueSearch, options);
  // console.log(store)
  new Vue({
    store: new Vuex.Store(store),
    render: h => h(App),
  }).$mount(el);
});
